import React from 'react';
import { WizzardWorkspaceModal } from './WizzardWorkspaceModal';
import { useStateSelector } from 'src/redux';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';
import useWzardInit from './useWzardInit';

export const WizzardWorkspace = () => {
  const wizardWorkspace = useStateSelector(({ app }) => app.wizardWorkspace);
  const { setWizardWorkspace } = useActionsApp();

  const { wizardValues, isLoading, isStdVarComplete } = useWzardInit();

  if (wizardWorkspace)
    return (
      <WizzardWorkspaceModal
        wizardData={wizardValues}
        isLoading={isLoading}
        isStdVarComplete={isStdVarComplete}
        onClose={() => setWizardWorkspace(null)}
      />
    );

  return null;
};
